// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Mobile photo-handoff page — standalone, mobile-first, premium. */

.MobilePhotos-page-G2cZE {
  min-height: 100vh;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  background: linear-gradient(160deg, #fff 0%, #fdf1f0 100%);
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
      -ms-flex-align: start;
          align-items: flex-start;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 24px 16px 48px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  color: #1a1a1a;
}

.MobilePhotos-card-pd9nM {
  width: 100%;
  max-width: 460px;
  background: #fff;
  border-radius: 20px;
  -webkit-box-shadow: 0 12px 40px rgba(17, 17, 17, 0.10);
          box-shadow: 0 12px 40px rgba(17, 17, 17, 0.10);
  padding: 28px 22px 32px;
  margin-top: 8px;
}

.MobilePhotos-logo-y75c6 {
  font-size: 18px;
  font-weight: 800;
  letter-spacing: -0.4px;
  color: #e23b2e;
  margin-bottom: 18px;
}

.MobilePhotos-title-nKyFs {
  font-size: 24px;
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: -0.5px;
  margin: 0 0 8px;
}

.MobilePhotos-sub-ERY42 {
  font-size: 15px;
  line-height: 1.5;
  color: #555;
  margin: 0 0 24px;
}

.MobilePhotos-cameraBtn-lYh8I {
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
  width: 100%;
  border: none;
  border-radius: 14px;
  background: #e23b2e;
  color: #fff;
  font-size: 17px;
  font-weight: 700;
  padding: 18px 16px;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  gap: 10px;
  -webkit-box-shadow: 0 8px 22px rgba(226, 59, 46, 0.30);
          box-shadow: 0 8px 22px rgba(226, 59, 46, 0.30);
  -webkit-transition: opacity 0.2s ease, -webkit-transform 0.06s ease, -webkit-box-shadow 0.2s ease;
  transition: opacity 0.2s ease, -webkit-transform 0.06s ease, -webkit-box-shadow 0.2s ease;
  transition: transform 0.06s ease, box-shadow 0.2s ease, opacity 0.2s ease;
  transition: transform 0.06s ease, box-shadow 0.2s ease, opacity 0.2s ease, -webkit-transform 0.06s ease, -webkit-box-shadow 0.2s ease;
}

.MobilePhotos-cameraBtn-lYh8I:active {
  -webkit-transform: scale(0.985);
      -ms-transform: scale(0.985);
          transform: scale(0.985);
}

.MobilePhotos-cameraBtn-lYh8I:disabled {
  opacity: 0.65;
  cursor: default;
}

.MobilePhotos-cameraIcon-apNEv {
  font-size: 20px;
}

.MobilePhotos-hiddenInput-hq0eN {
  display: none;
}

.MobilePhotos-error-ET7fC {
  margin-top: 14px;
  background: #fdecec;
  color: #b3261e;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 14px;
  line-height: 1.4;
}

.MobilePhotos-emptyNote-_bDEU {
  margin: 18px 2px 0;
  font-size: 13px;
  color: #888;
  line-height: 1.5;
}

.MobilePhotos-addedWrap-dbDX3 {
  margin-top: 24px;
}

.MobilePhotos-addedHead-eh29P {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #0f9d58;
  margin-bottom: 14px;
}

.MobilePhotos-check-qfF53 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #0f9d58;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
}

.MobilePhotos-thumbGrid-QZj_D {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.MobilePhotos-thumb-ovTGg {
  position: relative;
  width: 100%;
  padding-top: 100%;
  border-radius: 12px;
  overflow: hidden;
  background: #f2f2f2;
  border: 1px solid #eee;
}

.MobilePhotos-thumb-ovTGg img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
     object-fit: cover;
}

.MobilePhotos-doneNote-khHlC {
  margin: 16px 2px 0;
  font-size: 13px;
  color: #888;
  line-height: 1.5;
}

.MobilePhotos-expiredIcon-eFa56 {
  font-size: 40px;
  margin: 6px 0 12px;
}

/* Photo target guide — "take at least 8 photos" with a live counter + progress. */

.MobilePhotos-guide-LaxOA {
  margin: 0 0 20px;
  background: #fdf1f0;
  border: 1px solid #f6d8d4;
  border-radius: 14px;
  padding: 14px 16px;
}

.MobilePhotos-guideRow-gXcvP {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: baseline;
      -ms-flex-align: baseline;
          align-items: baseline;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  margin-bottom: 10px;
}

.MobilePhotos-guideLabel-xrn7Q {
  font-size: 14px;
  font-weight: 700;
  color: #1a1a1a;
}

.MobilePhotos-guideCount-cBqjN {
  font-size: 14px;
  font-weight: 800;
  color: #e23b2e;
}

.MobilePhotos-guideCount-cBqjN.MobilePhotos-met-ykYso {
  color: #0f9d58;
}

.MobilePhotos-progressTrack-OFKKL {
  width: 100%;
  height: 7px;
  border-radius: 999px;
  background: #f1d6d2;
  overflow: hidden;
}

.MobilePhotos-progressFill-dGfn_ {
  height: 100%;
  border-radius: 999px;
  background: #e23b2e;
  -webkit-transition: width 0.3s ease;
  transition: width 0.3s ease;
}

.MobilePhotos-progressFill-dGfn_.MobilePhotos-met-ykYso {
  background: #0f9d58;
}

.MobilePhotos-guideHint-IS_Kw {
  margin: 10px 0 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #8a6a66;
}

/* Secondary "I'm done" button to finish on the phone. */

.MobilePhotos-doneBtn-Bmk_a {
  -webkit-appearance: none;
  -moz-appearance: none;
       appearance: none;
  width: 100%;
  margin-top: 16px;
  border: 1.5px solid #e23b2e;
  border-radius: 14px;
  background: #fff;
  color: #e23b2e;
  font-size: 16px;
  font-weight: 700;
  padding: 15px 16px;
  cursor: pointer;
  -webkit-transition: background 0.2s ease, -webkit-transform 0.06s ease;
  transition: background 0.2s ease, -webkit-transform 0.06s ease;
  transition: transform 0.06s ease, background 0.2s ease;
  transition: transform 0.06s ease, background 0.2s ease, -webkit-transform 0.06s ease;
}

.MobilePhotos-doneBtn-Bmk_a.MobilePhotos-ready-ZMRpQ {
  background: #e23b2e;
  color: #fff;
  -webkit-box-shadow: 0 8px 22px rgba(226, 59, 46, 0.28);
          box-shadow: 0 8px 22px rgba(226, 59, 46, 0.28);
}

.MobilePhotos-doneBtn-Bmk_a:active {
  -webkit-transform: scale(0.985);
      -ms-transform: scale(0.985);
          transform: scale(0.985);
}

.MobilePhotos-finishedIcon-XMLWk {
  font-size: 44px;
  margin: 6px 0 12px;
}
`, "",{"version":3,"sources":["webpack://./src/routes/mobile-photos/MobilePhotos.css"],"names":[],"mappings":"AAAA,mEAAmE;;AAEnE;EACE,iBAAiB;EACjB,8BAAsB;UAAtB,sBAAsB;EACtB,0DAA0D;EAC1D,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,uBAAuB;EACvB,gGAAgG;EAChG,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sDAA8C;UAA9C,8CAA8C;EAC9C,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,SAAS;EACT,sDAA8C;UAA9C,8CAA8C;EAC9C,iGAAyE;EAAzE,yFAAyE;EAAzE,yEAAyE;EAAzE,qIAAyE;AAC3E;;AAEA;EACE,+BAAuB;MAAvB,2BAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAiB;KAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA,kFAAkF;;AAClF;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,2BAAqB;MAArB,wBAAqB;UAArB,qBAAqB;EACrB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mCAA2B;EAA3B,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wDAAwD;;AACxD;EACE,wBAAwB;EACxB,qBAAgB;OAAhB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,sEAAsD;EAAtD,8DAAsD;EAAtD,sDAAsD;EAAtD,oFAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,sDAA8C;UAA9C,8CAA8C;AAChD;;AAEA;EACE,+BAAuB;MAAvB,2BAAuB;UAAvB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["/* Mobile photo-handoff page — standalone, mobile-first, premium. */\n\n.page {\n  min-height: 100vh;\n  box-sizing: border-box;\n  background: linear-gradient(160deg, #fff 0%, #fdf1f0 100%);\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 24px 16px 48px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  color: #1a1a1a;\n}\n\n.card {\n  width: 100%;\n  max-width: 460px;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 12px 40px rgba(17, 17, 17, 0.10);\n  padding: 28px 22px 32px;\n  margin-top: 8px;\n}\n\n.logo {\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: -0.4px;\n  color: #e23b2e;\n  margin-bottom: 18px;\n}\n\n.title {\n  font-size: 24px;\n  line-height: 1.2;\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  margin: 0 0 8px;\n}\n\n.sub {\n  font-size: 15px;\n  line-height: 1.5;\n  color: #555;\n  margin: 0 0 24px;\n}\n\n.cameraBtn {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  border: none;\n  border-radius: 14px;\n  background: #e23b2e;\n  color: #fff;\n  font-size: 17px;\n  font-weight: 700;\n  padding: 18px 16px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  box-shadow: 0 8px 22px rgba(226, 59, 46, 0.30);\n  transition: transform 0.06s ease, box-shadow 0.2s ease, opacity 0.2s ease;\n}\n\n.cameraBtn:active {\n  transform: scale(0.985);\n}\n\n.cameraBtn:disabled {\n  opacity: 0.65;\n  cursor: default;\n}\n\n.cameraIcon {\n  font-size: 20px;\n}\n\n.hiddenInput {\n  display: none;\n}\n\n.error {\n  margin-top: 14px;\n  background: #fdecec;\n  color: #b3261e;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 14px;\n  line-height: 1.4;\n}\n\n.emptyNote {\n  margin: 18px 2px 0;\n  font-size: 13px;\n  color: #888;\n  line-height: 1.5;\n}\n\n.addedWrap {\n  margin-top: 24px;\n}\n\n.addedHead {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 15px;\n  font-weight: 700;\n  color: #0f9d58;\n  margin-bottom: 14px;\n}\n\n.check {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 50%;\n  background: #0f9d58;\n  color: #fff;\n  font-size: 13px;\n  font-weight: 800;\n}\n\n.thumbGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 8px;\n}\n\n.thumb {\n  position: relative;\n  width: 100%;\n  padding-top: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #f2f2f2;\n  border: 1px solid #eee;\n}\n\n.thumb img {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.doneNote {\n  margin: 16px 2px 0;\n  font-size: 13px;\n  color: #888;\n  line-height: 1.5;\n}\n\n.expiredIcon {\n  font-size: 40px;\n  margin: 6px 0 12px;\n}\n\n/* Photo target guide — \"take at least 8 photos\" with a live counter + progress. */\n.guide {\n  margin: 0 0 20px;\n  background: #fdf1f0;\n  border: 1px solid #f6d8d4;\n  border-radius: 14px;\n  padding: 14px 16px;\n}\n\n.guideRow {\n  display: flex;\n  align-items: baseline;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n\n.guideLabel {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a1a1a;\n}\n\n.guideCount {\n  font-size: 14px;\n  font-weight: 800;\n  color: #e23b2e;\n}\n\n.guideCount.met {\n  color: #0f9d58;\n}\n\n.progressTrack {\n  width: 100%;\n  height: 7px;\n  border-radius: 999px;\n  background: #f1d6d2;\n  overflow: hidden;\n}\n\n.progressFill {\n  height: 100%;\n  border-radius: 999px;\n  background: #e23b2e;\n  transition: width 0.3s ease;\n}\n\n.progressFill.met {\n  background: #0f9d58;\n}\n\n.guideHint {\n  margin: 10px 0 0;\n  font-size: 12.5px;\n  line-height: 1.5;\n  color: #8a6a66;\n}\n\n/* Secondary \"I'm done\" button to finish on the phone. */\n.doneBtn {\n  -webkit-appearance: none;\n  appearance: none;\n  width: 100%;\n  margin-top: 16px;\n  border: 1.5px solid #e23b2e;\n  border-radius: 14px;\n  background: #fff;\n  color: #e23b2e;\n  font-size: 16px;\n  font-weight: 700;\n  padding: 15px 16px;\n  cursor: pointer;\n  transition: transform 0.06s ease, background 0.2s ease;\n}\n\n.doneBtn.ready {\n  background: #e23b2e;\n  color: #fff;\n  box-shadow: 0 8px 22px rgba(226, 59, 46, 0.28);\n}\n\n.doneBtn:active {\n  transform: scale(0.985);\n}\n\n.finishedIcon {\n  font-size: 44px;\n  margin: 6px 0 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `MobilePhotos-page-G2cZE`,
	"card": `MobilePhotos-card-pd9nM`,
	"logo": `MobilePhotos-logo-y75c6`,
	"title": `MobilePhotos-title-nKyFs`,
	"sub": `MobilePhotos-sub-ERY42`,
	"cameraBtn": `MobilePhotos-cameraBtn-lYh8I`,
	"cameraIcon": `MobilePhotos-cameraIcon-apNEv`,
	"hiddenInput": `MobilePhotos-hiddenInput-hq0eN`,
	"error": `MobilePhotos-error-ET7fC`,
	"emptyNote": `MobilePhotos-emptyNote-_bDEU`,
	"addedWrap": `MobilePhotos-addedWrap-dbDX3`,
	"addedHead": `MobilePhotos-addedHead-eh29P`,
	"check": `MobilePhotos-check-qfF53`,
	"thumbGrid": `MobilePhotos-thumbGrid-QZj_D`,
	"thumb": `MobilePhotos-thumb-ovTGg`,
	"doneNote": `MobilePhotos-doneNote-khHlC`,
	"expiredIcon": `MobilePhotos-expiredIcon-eFa56`,
	"guide": `MobilePhotos-guide-LaxOA`,
	"guideRow": `MobilePhotos-guideRow-gXcvP`,
	"guideLabel": `MobilePhotos-guideLabel-xrn7Q`,
	"guideCount": `MobilePhotos-guideCount-cBqjN`,
	"met": `MobilePhotos-met-ykYso`,
	"progressTrack": `MobilePhotos-progressTrack-OFKKL`,
	"progressFill": `MobilePhotos-progressFill-dGfn_`,
	"guideHint": `MobilePhotos-guideHint-IS_Kw`,
	"doneBtn": `MobilePhotos-doneBtn-Bmk_a`,
	"ready": `MobilePhotos-ready-ZMRpQ`,
	"finishedIcon": `MobilePhotos-finishedIcon-XMLWk`
};
module.exports = ___CSS_LOADER_EXPORT___;
